module.exports = __webpack_public_path__ + "static/img/cjkj-logo.c4efb316.png";